import styled from 'styled-components';

import { Text } from '@gympass/yoga';
import { media } from '@gympass/yoga-helpers';

import { ImageContainerProps } from './types';

export const Container = styled.main`
  display: flex;
  min-height: 100vh;
  justify-content: center;
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
`;

export const SubContainer = styled.div`
  width: 100%;
  position: relative;

  ${media.md`
    width: 80%;
  `};

  ${media.lg`
    width: 60%;
  `};
`;

export const ImageContainer = styled.div<ImageContainerProps>`
  display: ${({ displayInMobile }) => (displayInMobile ? 'block' : 'none')};
  padding: ${({ theme }) => theme.yoga.spacing.xlarge}px
    ${({ theme }) => theme.yoga.spacing.medium}px
    ${({ theme }) => theme.yoga.spacing.zero}px;

  ${media.md`
    display: block;
  `};
`;

export const MobileNavigationHeader = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  background-color: ${({ theme }) => theme.yoga.colors.white};
  padding: ${({ theme }) => theme.yoga.spacing.medium}px
    ${({ theme }) => theme.yoga.spacing.large}px;

  ${media.md`
    display: none;
  `};
`;

export const NavigationButtonLabel = styled(Text.Small)`
  width: 100%;
  text-align: center;
  padding-left: ${({ theme }) => theme.yoga.spacing.small}px;
  padding-right: ${({ theme }) => theme.yoga.spacing.small}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
`;

export const LoginCard = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  padding: ${({ theme }) => theme.yoga.spacing.medium}px;

  ${({ theme }) =>
    media.md`
        padding: ${theme.yoga.spacing.xxxlarge}px;
        border-radius: ${theme.yoga.radii.small}px;
        box-shadow: ${theme.yoga.elevations.medium}px;
        background-color: ${theme.yoga.colors.white};
      `};
`;

export const LoginSubCard = styled.div`
  width: 100%;

  ${media.md`
    width: 80%;
  `};

  ${media.lg`
    width: 60%;
  `};
`;
